import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import clsx from 'clsx';

import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import RightArrowIcon from '@yaydoo/react-components/lib/icons/CaretRight';
import Radio from '@yaydoo/react-components/lib/components/Radio';

import { FilterComponentProps } from './types';
import useStyles from './styles';

const MobileFilters: FC<FilterComponentProps> = ({
  currentLinkStatus,
  linkStatusOptions,
  onChangeLinkStatus,
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const css = useStyles();
  const arrowCls = clsx({ [css.arrowDown]: isOpen }, css.arrow);

  const toggleOpen = () => {
    setIsOpen((isOpen) => !isOpen);
  };

  const handleOnChange =
    (callback: () => void, toggle = true) =>
    () => {
      toggle && toggleOpen();
      callback();
    };

  const linkFilters = (
    <div>
      {linkStatusOptions.map(({ label, icon: Icon, value }) => (
        <Radio
          size="small"
          key={label}
          className={css.innerFilter}
          checked={currentLinkStatus === value}
          onClick={handleOnChange(() => onChangeLinkStatus(value))}
          label={
            <span className={css.innerFilterOption}>
              <Icon className={css.icon} />
              {label}
            </span>
          }
          labelPlacement="end"
        />
      ))}
    </div>
  );

  return (
    <Accordion
      expanded={isOpen}
      className={css.mobileContainer}
      data-testid="mobile-filters"
      square
      elevation={0}
    >
      <AccordionSummary onClick={toggleOpen} classes={{ root: css.accordionSummary }}>
        <div className={css.filtersButton}>
          {t('collect.payments.filters.title')}
          <RightArrowIcon className={arrowCls} defaultColor />
        </div>
      </AccordionSummary>
      <AccordionDetails classes={{ root: css.accordionDetails }}>
        <div className={css.filtersMenu}>
          <div className={css.filtersOptions}>{linkFilters}</div>
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

export default observer(MobileFilters);
